import MessageBox from "sap/m/MessageBox";
import BaseController from "./BaseController";
import "reflect-metadata";

import JSONModel from "sap/ui/model/json/JSONModel";

/**
 * @namespace ang.order_portal.controller
 */
export default class Main extends BaseController {
	public sayHello(): void {
		MessageBox.show("Hello World!");
	}
}
